import AbstractEditWidget from "../../../cluetrainer/ui/widgets/AbstractEditWidget";
import { C } from "../constructors";
var cls = C.cls;
export class ColorPicker extends AbstractEditWidget {
    constructor() {
        super(cls("nisl-color-input"));
        this.input = c("<input type='color'>")
            .on("change", (v) => {
            this.commit(this.input.container.val());
        })
            .appendTo(this);
    }
    render() {
        this.input.raw().value = this.get();
    }
}
